import {
  type ElementTiming,
  resolveSceneBoundaryAnchors,
} from './sceneAnchors';

import type { Scene } from '@src/editor/models/layout/Scene';
import type { AnchorType } from '@src/editor/models/layout/types';

export interface BoundaryAdjustmentInput {
  boundaryTime: number;
  elementTimings: ElementTiming[];
}

export interface SceneAnchorUpdate {
  sceneId: string;
  anchors: {
    start?: AnchorType;
    end?: AnchorType;
  };
}

export function buildSceneBoundaryAnchorUpdates(
  leftScene: Scene,
  rightScene: Scene,
  { boundaryTime, elementTimings }: BoundaryAdjustmentInput,
): SceneAnchorUpdate[] | null {
  if (!leftScene || !rightScene) {
    return null;
  }

  const anchors = resolveSceneBoundaryAnchors(
    boundaryTime,
    elementTimings,
    'end',
  );

  if (!anchors) {
    return null;
  }

  return [
    {
      sceneId: leftScene.id,
      anchors: {
        end: anchors.current,
      },
    },
    {
      sceneId: rightScene.id,
      anchors: {
        start: anchors.adjacent,
      },
    },
  ];
}
